import React, {memo} from "react";
import {useTranslation} from "react-i18next";
//local
import {IconBag, IconFeather} from "components/icons";
import {RichEditor} from "components/RichEditor";
import {TitleIcon} from "components/TitleIcon";
import {notUndefined} from "helpers/helper";
import {color} from "constants/color.consts";

export const ContractViewInfo = memo(({price, additions, currencyCode}) => {
  const {t} = useTranslation();

  return (
    <div className="contract-tab__contract-view-block mb-8 mt-12">
      <TitleIcon title={t("PRICE")} icon={<IconBag />} />
      <div className="contract-tab__contract-view-block__price-value">
        {price || "0"}
        <div className="contract-tab__contract-view-block__price-denomination">
          {currencyCode}
        </div>
      </div>

      <TitleIcon
        title={t("ADDITIONS_ADJUSTMENTS")}
        addClass="mt-12"
        icon={<IconFeather color={color.black} />}
      />
      {notUndefined(additions) && (
        <RichEditor
          initialValue={additions}
          mode="view"
          placeholder="NO_ADDITIONS_PLACEHOLDER"
        />
      )}
    </div>
  );
});
